export default __webpack_public_path__ + "static/media/V_Vinyl.bcd3f662.jpg";